import React, { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';

export const GallerySection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [
    '/realisation-1.jpeg',
    '/realisation-2.jpeg',
    '/realisation-3.jpeg',
    '/realisation-4.jpeg',
    '/realisation-5.jpeg',
    '/realisation-6.jpeg',
    '/realisation-7.jpeg',
    '/realisation-8.jpeg',
    '/realisation-9.jpeg',
    '/realisation-10.jpeg',
    '/realisation-11.jpeg'
  ];

  // Auto-scroll effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 4000); // Change image every 4 seconds

    return () => clearInterval(interval);
  }, [images.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center gap-3 bg-blue-100 px-6 py-3 rounded-full mb-4">
            <CheckCircle className="text-blue-600" size={28} />
            <span className="text-blue-600 font-bold text-lg">Chantiers Terminés</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos Réalisations
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Découvrez la qualité de notre travail à travers nos projets récents
          </p>
        </div>

        {/* Carousel Container */}
        <div className="relative overflow-hidden rounded-3xl shadow-2xl">
          {/* Images Track */}
          <div 
            className="flex transition-transform duration-700 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {images.map((image, index) => (
              <div key={index} className="min-w-full">
                <img
                  src={image}
                  alt={`Chantier terminé ${index + 1}`}
                  className="w-full h-[600px] object-cover"
                />
              </div>
            ))}
          </div>

          {/* Navigation Dots */}
          <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex gap-3 bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg">
            {images.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  index === currentIndex
                    ? 'bg-blue-600 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>

          {/* Progress Bar */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gray-200">
            <div 
              className="h-full bg-blue-600 transition-all duration-[4000ms] ease-linear"
              style={{ 
                width: `${((currentIndex + 1) / images.length) * 100}%` 
              }}
            />
          </div>
        </div>

        {/* Stats Below Gallery */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center transform hover:scale-105 transition-transform duration-300">
            <div className="text-4xl font-bold text-blue-600 mb-2">500+</div>
            <div className="text-gray-600 font-medium">Chantiers Terminés</div>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center transform hover:scale-105 transition-transform duration-300">
            <div className="text-4xl font-bold text-blue-600 mb-2">100%</div>
            <div className="text-gray-600 font-medium">Clients Satisfaits</div>
          </div>
          <div className="bg-white p-6 rounded-2xl shadow-lg text-center transform hover:scale-105 transition-transform duration-300">
            <div className="text-4xl font-bold text-blue-600 mb-2">15+</div>
            <div className="text-gray-600 font-medium">Années d'Expérience</div>
          </div>
        </div>
      </div>
    </section>
  );
};
